export function useClipboard() {
  return (url: string) => {
    if (!window.isSecureContext && !navigator.clipboard)
      return Promise.reject();

    return navigator.clipboard.writeText(url);
  };
}
